module.exports = __webpack_public_path__ + "static/media/fotogalereya10.af1c57db.jpg";